import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`

console.log(API_URL, "API_URL")

export const trainerCreateApi = async (data) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.post(
            `${API_URL}auth/trainer-create`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Error creating Trainer:', error);
        throw error;
    }
}

export const fetchTrainerDetails = async (pageNo = 1, limit = 10) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.get(`${API_URL}auth/trainer-create`, {
            params: { pageNo, limit },
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching Trainer:', error);
        throw error;
    }
}

export const deleteTrainerDetails = async (data) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        let payload = {
            trainerId: data
        }
        const response = await axios.delete(
            `${API_URL}auth/trainer-create`,
            {
                data: payload,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Error deleting Trainer:', error);
        throw error;
    }
}


export const updateTrainerDetails = async (data) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.patch(
            `${API_URL}auth/trainer-create`,
            { data: data },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Error updating Trainer:', error);
        throw error;
    }
}

